export const API_CONFIG = {
  baseURL: `${process.env.REACT_APP_API}`,
};
